module.exports = __webpack_public_path__ + "static/assets/9866ab77b90e2820a7c9ad2ad42b63fd.png";